import type { PortfolioPrintMode } from "portfolio/types";

export const PORTFOLIO_PRINT_MODES = {
  All: "all",
  Filters: "filters",
} as const satisfies Record<string, PortfolioPrintMode>;

export const PORTFOLIO_PRINT_MODE_LABEL: Record<PortfolioPrintMode, string> = {
  [PORTFOLIO_PRINT_MODES.All]: "Alles printen",
  [PORTFOLIO_PRINT_MODES.Filters]: "Geselecteerde filters printen",
};

export const PORTFOLIO_PRINT_MODE_OPTIONS = Object.values(
  PORTFOLIO_PRINT_MODES,
).map((value) => ({
  label: PORTFOLIO_PRINT_MODE_LABEL[value],
  value,
}));
